import React, { Component } from "react";
import Carousel, { SlickItem } from "../../../../SPRINTA/third-party/SlickCarousel";

import styles from "./styles.css";

export class AccordionCarrousel extends Component {
  render() {
    const { items } = this.props;
    return (
      <div className={styles.container}>
        <p>Algumas premiações que você pode trocar. <a href="https://app.sprinta.com.br/club/35730def964e648" target="_blank">Veja mais aqui</a>.</p>

        <Carousel
          arrowTop="0%"
          itens={2}
          arrows={items.length > 2}
          dots={items.length > 2}
          centerPadding="20px"
        >
          {items.map((card) => (
            <SlickItem key={card.id}>
              <div className={styles.card}>
                <img src={card.image} alt={card.name} />
                <div>
                  
                  <span><b>{card.cost}  pontos</b><br />{card.name}</span>
                </div>
              </div>
            </SlickItem>
          ))}
        </Carousel>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/event/PrizeAccordion/AccordionCarrousel/index.jsx